import localforage from 'localforage';

localforage.config({
  driver: localforage.INDEXEDDB,
  name: 'TAPAS_EPUB_VIEWER',
  storeName: 'TAPAS_EPUB_VIEWER_STORAGE',
});

export default localforage;
